// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var EmailUnread = function EmailUnread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.222 7.778a2.778 2.778 0 1 0 0-5.556 2.778 2.778 0 0 0 0 5.556m.556 7.778V8.85c-.18.024-.368.038-.556.038-.781 0-1.51-.23-2.118-.629l-4.982 4.09c-.72.59-1.75.59-2.47 0L1.668 7.435v-.767c0-.306.25-.556.555-.556h11.271a3.9 3.9 0 0 1-.122-1.667H2.223A2.224 2.224 0 0 0 0 6.667v8.889c0 1.225.997 2.222 2.222 2.222h13.334a2.224 2.224 0 0 0 2.222-2.222M1.667 9.59l4.93 4.049a3.61 3.61 0 0 0 4.584 0l4.93-4.049v5.966c0 .305-.25.555-.555.555H2.222a.557.557 0 0 1-.555-.556z"
  }));
};
